import { useEffect, useState } from "react";
import { fetchCategories, fetchProducts } from "../services/api";
import { CATEGORIES as FALLBACK, CATEGORY_LABEL } from "../data/products";

// Live bracelet categories for the header mega-menu, enriched with published
// product counts. Only categories that actually contain products are returned,
// sorted by size. Falls back to the static list if the API is unavailable.
export const useCategoryNav = () => {
  const [cats, setCats] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      let base = [];
      try {
        const live = await fetchCategories();
        base = (live || [])
          .filter((c) => c.slug)
          .map((c) => ({ id: c.slug, label: c.name || CATEGORY_LABEL[c.slug] || c.slug }));
      } catch {
        base = [];
      }
      if (!base.length) base = FALLBACK.map((c) => ({ id: c.id, label: c.label }));

      const withCounts = await Promise.all(
        base.map(async (c) => {
          try {
            const r = await fetchProducts({ category: c.id, limit: 1 });
            return { ...c, count: r.total || 0 };
          } catch {
            return { ...c, count: 0 };
          }
        })
      );
      const filtered = withCounts.filter((c) => c.count > 0).sort((a, b) => b.count - a.count);
      if (active) setCats(filtered.length ? filtered : withCounts);
    })();
    return () => {
      active = false;
    };
  }, []);

  return cats;
};
